export default function highlightSidebar () {
  const activeItem = document.querySelector('.MainList-link--active')

  if (activeItem) {
    const parentEl = activeItem.parentNode
    if (!parentEl.classList.contains('MainList-item--read')) {
      setTimeout(() => {
        parentEl.classList.add('MainList-item--reading')
      }, 500)

      setTimeout(() => {
        parentEl.classList.remove('MainList-item--reading')
        parentEl.classList.add('MainList-item--read')
      }, 2000)
    }
  }
}
